module.exports = __webpack_public_path__ + "static/media/contact-slide-4.f41bba5b.jpg";